// Carousel Block Frontend Initialization

document.addEventListener('DOMContentLoaded', function() {
    // Initialize all carousels on the page
    initializeCarousels();
});

function initializeCarousels() {
    const carousels = document.querySelectorAll('.wp-block-invoka-carousel');

    carousels.forEach(carousel => {
        // Skip if already initialized
        if (carousel.classList.contains('swiper-initialized')) {
            return;
        }

        // Get the configuration from the script tag
        const configScript = carousel.querySelector('.swiper-config');
        if (!configScript) {
            return;
        }

        let config;
        try {
            config = JSON.parse(configScript.textContent);
        } catch (e) {
            console.error('Invalid Swiper configuration:', e);
            return;
        }

        // Clean up the config script
        configScript.remove();

        // Initialize Swiper
        const swiper = new Swiper(carousel.querySelector('.swiper'), config);

        // Mark as initialized
        carousel.classList.add('swiper-initialized');

        // Store swiper instance for potential future use
        carousel._swiper = swiper;
    });
}

// Re-initialize carousels when new content is loaded (e.g., via AJAX)
window.addEventListener('load', function() {
    // Use a timeout to ensure DOM is fully ready
    setTimeout(initializeCarousels, 100);
});

// Also initialize on custom events that might add new blocks
document.addEventListener('blocksLoaded', initializeCarousels);
document.addEventListener('contentUpdated', initializeCarousels);